<ion-toolbar color="--ion-color-light-teal-2" class="ion-text-center">
    <ion-buttons slot="end">
        <ion-button id="goToVerifyEligibilityDismissBtn" (click)="dismiss()">
            <ion-icon slot="icon-only" name="close"></ion-icon>
        </ion-button>
    </ion-buttons>
</ion-toolbar>

<ion-content class="white">
    <ion-row class="white">
        <ion-col size="12">
            <ion-row>
                <ion-col *ngIf="icon?.name" class="text-center" size="12">
                    <ion-text>
                        <ion-icon
                            [class]="icon?.class"
                            [color]="icon?.color"
                            [size]="icon?.size"
                            [name]="icon?.name"
                        ></ion-icon>
                    </ion-text>
                </ion-col>
                <ion-col size="12">
                    <ion-text
                        *ngFor="let message of messages"
                        [class]="message?.class"
                    >
                        <p *ngIf="message?.type === 'stringParagraph'">
                            {{ message?.text }}
                        </p>
                        <h4 *ngIf="message?.type === 'string'">
                            {{ message?.text }}
                        </h4>
                        <h4
                            [innerHtml]="message?.text"
                            *ngIf="message?.type === 'html'"
                        ></h4>
                    </ion-text>
                </ion-col>
                <ion-col
                    class="text-center"
                    size="12"
                    *ngIf="type === 'switchprotection'"
                >
                    <ion-button
                        size="small"
                        target="_blank"
                        href="https://landing.amopportunities.org/switch-protection-terms"
                        >Terms of Service</ion-button
                    >
                </ion-col>
            </ion-row>
        </ion-col>
    </ion-row>
</ion-content>

<ion-footer>
    <ion-row>
        <ion-col class="ion-text-center">
            <ion-button
                class="btncta"
                *ngFor="let button of buttons"
                id="{{ button?.id }}"
                mode="md"
                [fill]="button?.fill"
                [color]="button?.color"
                type="button"
                (click)="ctaClick(button?.type)"
            >
                {{ button?.text }}
            </ion-button>
        </ion-col>
    </ion-row>
</ion-footer>
